import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { ButtonText } from '@powdr/constants';

export const WeddingsForm = ({
  reCaptchaPublicKey,
  processForm,
  isUserVerified,
  setUserVerified,
  handleCaptchaExpiry,
  buttonText,
}) => {
  const captchaRef = useRef();

  return (
    <form
      onSubmit={(e) => processForm(e, 'buk_WQ2jQpkGFhd9cvnSMWv04CR6', null, captchaRef)}
      id="weddings-rfp-form"
    >
      <p>We're so excited you're considering us for your special day. Tell us a little bit more about your plans and we’ll be in touch with more information soon.</p>
      <div className="form-group">
        <h3 className="u-inline">
          Where did you hear about Copper Mountain?
        </h3>
        <ul className="l-group">
          <li className="l-item">
            <input
              className="radio"
              id="research1"
              value="Copper/IKON Passholder"
              type="radio"
              name="research"
            />
            <label htmlFor="research1">Copper/IKON Passholder</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="research2"
              value="Google Search"
              type="radio"
              name="research"
            />
            <label htmlFor="research2">Google Search</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="research3"
              value="The Knot / Wedding Wire"
              type="radio"
              name="research"
            />
            <label htmlFor="research3">The Knot / Wedding Wire</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="research4"
              value="Here Comes the Guide"
              type="radio"
              name="research"
            />
            <label htmlFor="research4">Here Comes the Guide</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="research5"
              value="Recommendation"
              type="radio"
              name="research"
            />
            <label htmlFor="research5">Recommendation</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="research6"
              value="Other"
              type="radio"
              name="research"
            />
            <label htmlFor="research6">Other</label>
          </li>
        </ul>

        <h3>First Name *</h3>
        <input
          className="form-control"
          id="firstName"
          name="firstName"
          type="text"
          required
        />

        <h3>Last Name *</h3>
        <input
          className="form-control"
          id="lastName"
          name="lastName"
          type="text"
          required
        />

        <h3>Partner's Name</h3>
        <input
          className="form-control"
          id="partnersName"
          name="partnersName"
          type="text"
        />

        <h3>Address *</h3>
        <input
          className="form-control"
          id="address"
          name="address"
          type="text"
          required
        />

        <h3>State *</h3>
        <select className="form-control" id="state" name="state" required>
          <option selected="selected">
            - select a state -
          </option>
          <option value="AL">Alabama</option>
          <option value="AK">Alaska</option>
          <option value="AB">Alberta</option>
          <option value="AZ">Arizona</option>
          <option value="AR">Arkansas</option>
          <option value="BC">British Columbia</option>
          <option value="CA">California</option>
          <option value="CO">Colorado</option>
          <option value="CT">Connecticut</option>
          <option value="DE">Delaware</option>
          <option value="DC">District of Columbia</option>
          <option value="FL">Florida</option>
          <option value="GA">Georgia</option>
          <option value="HI">Hawaii</option>
          <option value="ID">Idaho</option>
          <option value="IL">Illinois</option>
          <option value="IN">Indiana</option>
          <option value="IA">Iowa</option>
          <option value="KS">Kansas</option>
          <option value="KY">Kentucky</option>
          <option value="LA">Louisiana</option>
          <option value="ME">Maine</option>
          <option value="MB">Manitoba</option>
          <option value="MD">Maryland</option>
          <option value="MA">Massachusetts</option>
          <option value="MI">Michigan</option>
          <option value="MN">Minnesota</option>
          <option value="MS">Mississippi</option>
          <option value="MO">Missouri</option>
          <option value="MT">Montana</option>
          <option value="NE">Nebraska</option>
          <option value="NV">Nevada</option>
          <option value="NB">New Brunswick</option>
          <option value="NH">New Hampshire</option>
          <option value="NJ">New Jersey</option>
          <option value="NM">New Mexico</option>
          <option value="NY">New York</option>
          <option value="NL">Newfoundland and Labrador</option>
          <option value="NC">North Carolina</option>
          <option value="ND">North Dakota</option>
          <option value="NT">Northwest Territories</option>
          <option value="NS">Nova Scotia</option>
          <option value="NU">Nunavut</option>
          <option value="OH">Ohio</option>
          <option value="OK">Oklahoma</option>
          <option value="ON">Ontario</option>
          <option value="OR">Oregon</option>
          <option value="PA">Pennsylvania</option>
          <option value="PE">Prince Edward Island</option>
          <option value="QC">Quebec</option>
          <option value="RI">Rhode Island</option>
          <option value="SK">Saskatchewan</option>
          <option value="SC">South Carolina</option>
          <option value="SD">South Dakota</option>
          <option value="TN">Tennessee</option>
          <option value="TX">Texas</option>
          <option value="UT">Utah</option>
          <option value="VT">Vermont</option>
          <option value="VA">Virginia</option>
          <option value="WA">Washington</option>
          <option value="WV">West Virginia</option>
          <option value="WI">Wisconsin</option>
          <option value="WY">Wyoming</option>
          <option value="YT">Yukon</option>
        </select>

        <h3>Zip / Postal Code *</h3>
        <input
          className="form-control"
          id="zipcode"
          name="zipCode"
          type="text"
          required
        />

        <h3>Phone *</h3>
        <input
          className="form-control"
          id="phoneNumber"
          name="phoneNumber"
          type="tel"
          required
        />

        <h3>Email address *</h3>
        <input
          className="form-control"
          id="email"
          name="email"
          type="email"
          required
        />

        <h3>Preferred method of communication</h3>
        <select className="form-control" id="comm-preference" name="comm-preference">
          <option selected="selected">
            - preference -
          </option>
          <option value="phone">Phone</option>
          <option value="email">Email</option>
          <option value="text">Text</option>
        </select>

        <h3>
          Event Type *
        </h3>
        <ul className="l-group">
          <li className="l-item">
            <input
              className="radio"
              id="eventType1"
              value="Wedding"
              type="radio"
              name="eventType"
              defaultChecked
              required
            />
            <label htmlFor="eventType1">Wedding</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="eventType2"
              value="Elopement"
              type="radio"
              name="eventType"
            />
            <label htmlFor="eventType2">Elopement</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="eventType3"
              value="Anniversary"
              type="radio"
              name="eventType"
            />
            <label htmlFor="eventType3">Anniversary</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="eventType4"
              value="Renewal of Vows"
              type="radio"
              name="eventType"
            />
            <label htmlFor="eventType4">Renewal of Vows</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="eventType5"
              value="Other"
              type="radio"
              name="eventType"
            />
            <label htmlFor="eventType5">Other</label>
          </li>
        </ul>

        <h3>Event Details</h3>

        <h4>Event Date *</h4>
        <input
          className="form-control"
          id="eventdate"
          name="eventdate"
          type="date"
          required
        />

        <h4>Are you flexible with your date?</h4>
        <ul className="l-group">
          <li className="l-item">
            <input
              className="radio"
              id="flexibility1"
              value="Yes"
              type="radio"
              name="flexibility"
              required
            />
            <label htmlFor="flexibility1">Yes</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="flexibility2"
              value="No"
              type="radio"
              name="flexibility"
              defaultChecked
            />
            <label htmlFor="flexibility2">No</label>
          </li>
        </ul>

        <h4>Estimated Guest Count *</h4>
        <ul className="l-group">
          <li className="l-item">
            <input
              className="radio"
              id="guestCount1"
              value="0-50"
              type="radio"
              name="guestCount"
              required
              defaultChecked
            />
            <label htmlFor="guestCount1">0-50</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="guestCount2"
              value="50-75"
              type="radio"
              name="guestCount"
            />
            <label htmlFor="guestCount2">50-75</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="guestCount3"
              value="76-100"
              type="radio"
              name="guestCount"
            />
            <label htmlFor="guestCount3">76-100</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="guestCount4"
              value="101-150"
              type="radio"
              name="guestCount"
            />
            <label htmlFor="guestCount4">101-150</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="guestCount5"
              value="151-200"
              type="radio"
              name="guestCount"
            />
            <label htmlFor="guestCount5">151-200</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="guestCount6"
              value="200+"
              type="radio"
              name="guestCount"
            />
            <label htmlFor="guestCount6">200+</label>
          </li>
        </ul>

        <h4>Estimated Budget *</h4>
        <ul className="l-group">
          <li className="l-item">
            <input
              className="radio"
              id="budget1"
              value="Less than $5,000"
              type="radio"
              name="budget"
              required
              defaultChecked
            />
            <label htmlFor="budget1">Less than $5,000</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="budget2"
              value="$5,000 - $14,999"
              type="radio"
              name="budget"
            />
            <label htmlFor="budget2">$5,000 - $14,999</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="budget3"
              value="$15,000 - $24,999"
              type="radio"
              name="budget"
            />
            <label htmlFor="budget3">$15,000 - $24,999</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="budget4"
              value="$25,000 - $34,999"
              type="radio"
              name="budget"
            />
            <label htmlFor="budget4">$25,000 - $34,999</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="budget5"
              value="$35,000 - $44,999"
              type="radio"
              name="budget"
            />
            <label htmlFor="budget5">$35,000 - $44,999</label>
          </li>

          <li className="l-item">
            <input
              className="radio"
              id="budget6"
              value="$50,000"
              type="radio"
              name="budget"
            />
            <label htmlFor="budget6">$50,000</label>
          </li>
        </ul>

        <h3>What events are you planning?</h3>
        <ul className="l-group">
          <li className="l-item">
            <input
              className="checkbox"
              id="ceremony"
              name="eventPlans"
              type="checkbox"
              value="Ceremony"
            />
            <label htmlFor="ceremony">Ceremony</label>
          </li>

          <li className="l-item">
            <input
              className="checkbox"
              id="reception"
              name="eventPlans"
              type="checkbox"
              value="Reception"
            />
            <label htmlFor="reception">Reception</label>
          </li>

          <li className="l-item">
            <input
              className="checkbox"
              id="rehearsal-dinner"
              name="eventPlans"
              type="checkbox"
              value="Rehearsal Dinner"
            />
            <label htmlFor="rehearsal-dinner">Rehearsal Dinner</label>
          </li>

          <li className="l-item">
            <input
              className="checkbox"
              id="welcome-social"
              name="eventPlans"
              type="checkbox"
              value="Welcome Social"
            />
            <label htmlFor="welcome-social">Welcome Social</label>
          </li>

          <li className="l-item">
            <input
              className="checkbox"
              id="farewell-brunch"
              name="eventPlans"
              type="checkbox"
              value="Farewell Brunch"
            />
            <label htmlFor="farewell-brunch">Farewell Brunch</label>
          </li>
        </ul>

        <h3>Which ceremony venue are you interested in?</h3>
        <ul className="l-group">
          <li className="l-item">
            <input
              className="checkbox"
              id="aerie-ceremony"
              name="ceremonyVenue"
              type="checkbox"
              value="Aerie"
            />
            <label htmlFor="aerie-ceremony">Aerie</label>
          </li>

          <li className="l-item">
            <input
              className="checkbox"
              id="copper-creek-vista"
              name="ceremonyVenue"
              type="checkbox"
              value="Copper Creek Vista"
            />
            <label htmlFor="copper-creek-vista">Copper Creek Vista</label>
          </li>

          <li className="l-item">
            <input
              className="checkbox"
              id="kokos-hut"
              name="ceremonyVenue"
              type="checkbox"
              value="Koko's Hut"
            />
            <label htmlFor="kokos-hut">Koko's Hut</label>
          </li>

          <li className="l-item">
            <input
              className="checkbox"
              id="copper-chapel"
              name="ceremonyVenue"
              type="checkbox"
              value="Copper Chapel"
            />
            <label htmlFor="copper-chapel">Copper Chapel</label>
          </li>

          <li className="l-item">
            <input
              className="checkbox"
              id="unsure-ceremony"
              name="ceremonyVenue"
              type="checkbox"
              value="Unsure - Would love to explore all the options"
            />
            <label htmlFor="unsure-ceremony">Unsure - Would love to explore all the options</label>
          </li>
        </ul>

        <h3>Which reception venue are you interested in?</h3>
        <ul className="l-group">
          <li className="l-item">
            <input
              className="checkbox"
              id="aerie-reception"
              name="receptionVenue"
              type="checkbox"
              value="Aerie"
            />
            <label htmlFor="aerie-reception">Aerie</label>
          </li>

          <li className="l-item">
            <input
              className="checkbox"
              id="grand-hall"
              name="receptionVenue"
              type="checkbox"
              value="Copper Creek Vista"
            />
            <label htmlFor="grand-hall">Grand Hall</label>
          </li>

          <li className="l-item">
            <input
              className="checkbox"
              id="jjs-rocky-mountain-tavern"
              name="receptionVenue"
              type="checkbox"
              value="JJ's Rocky Mountain Tavern"
            />
            <label htmlFor="jjs-rocky-mountain-tavern">JJ's Rocky Mountain Tavern</label>
          </li>

          <li className="l-item">
            <input
              className="checkbox"
              id="unsure-reception"
              name="receptionVenue"
              type="checkbox"
              value="Unsure - Would love to explore all the options"
            />
            <label htmlFor="unsure-reception">Unsure - Would love to explore all the options</label>
          </li>
        </ul>

        <h3>Is there anything else you would like to ask or let us know</h3>
        <textarea name="additional-info" id="additional-info" rows="9" cols="33" />
      </div>

      <ReCAPTCHA
        ref={captchaRef}
        className="recaptcha"
        sitekey={reCaptchaPublicKey}
        theme="light"
        size="normal"
        onChange={() => setUserVerified(true)}
        onExpired={() => handleCaptchaExpiry()}
      />
      <button type="submit" value="Submit" disabled={!isUserVerified}>
        {buttonText || ButtonText.SUBMIT}
      </button>
    </form>
  );
};

WeddingsForm.propTypes = {
  reCaptchaPublicKey: PropTypes.string.isRequired,
  processForm: PropTypes.func.isRequired,
  setUserVerified: PropTypes.func.isRequired,
  isUserVerified: PropTypes.bool.isRequired,
  handleCaptchaExpiry: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
};

WeddingsForm.defaultProps = {
  buttonText: null,
};
